const intialState = {
    user : {},
}

const userSelectReducer = (state = intialState, action ) => {
    //console.log("In the  user reducer", action)
    switch(action.type){
        case "UPDATE_THE_USER":
            return {
                ...state,
                user : action.data
            }
        default:
            return state;
    }
}

export const updateTheUser = (user) => {
    //console.log("updating user in store")
    return {
        type : "UPDATE_THE_USER",
        data : user
    }
}

export default userSelectReducer